const APP_NAME = process.env.NEXT_PUBLIC_APP_NAME;

export function ManifestFile() {
    const manifestHref = APP_NAME
        ? `/${APP_NAME}/manifest.json`
        : '/manifest.json';
    /**
     * The request for the manifest is made without credentials, even if it's on the same domain.
     * Without crossOrigin="use-credentials" traffic splitter is not able to determine
     * where to route the request
     *
     * Fixed in Next v14.2.0 (https://github.com/vercel/next.js/pull/62873)
     */
    return (
        <link
            rel="manifest"
            href={manifestHref}
            crossOrigin="use-credentials"
        />
    );
}
